// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';

import { Container } from './styled';
import { BsStarFill, BsStar } from 'react-icons/bs';
import Rate from '../../components/rate';

interface RateComponentsProps {
    grading: number;
    color?: string;
    style?: {};
    disable?: boolean;
    onClick?: (n: number) => void;
}

const RateContainer = ({ grading, color, style, disable = false, onClick }: RateComponentsProps) => {
    const [value, setValue] = useState(grading);

    // eslint-disable-next-line no-undef
    const newStars: JSX.Element[] = [];

    for (let i = 0; i < 5; i++) {
        const handleOnclick = () => {
            if (!disable) {
                setValue(i + 1);
                // console.log(i + 1);
                onClick && onClick(i + 1);
            }
        };

        if (i + 1 <= value) {
            newStars.push(
                <Container
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }}
                    key={i}
                >
                    <BsStarFill color={color} onMouseUp={handleOnclick} onClick={handleOnclick} />
                </Container>
            );
        } else {
            newStars.push(
                <Container
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }}
                    key={i}
                >
                    <BsStar width="100%" color={'#999'} onMouseUp={handleOnclick} onClick={handleOnclick} />
                </Container>
            );
        }
    }

    return <Rate style={style} stars={newStars} />;
};

export default RateContainer;
